import React from 'react';
import styled from 'styled-components';

const BadgeContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  
  &.gold {
    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    color: #78350f;
    box-shadow: 0 2px 8px rgba(251, 191, 36, 0.3);
  }
  
  &.green {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
  }
  
  &.blue {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  }
  
  &.gray {
    background: #f3f4f6;
    color: #6b7280;
  }
  
  .icon {
    font-size: 14px;
  }
`;

const VerificationBadge = ({ user, variant = 'small' }) => {
  if (!user) return null;

  // Determine badge level based on user data
  const isPhoneVerified = user.phoneVerified || user.phone_verified;
  const isEmailVerified = user.emailVerified || user.email_verified;
  const rating = parseFloat(user.rating) || 0;
  const reviewCount = parseInt(user.review_count) || 0;

  // Elite: 200+ sales, rating > 4.8, verified
  const isElite = reviewCount >= 200 && rating >= 4.8 && isPhoneVerified && isEmailVerified;
  
  // Pro: 50+ sales, rating > 4.5, verified
  const isPro = reviewCount >= 50 && rating >= 4.5 && isPhoneVerified && isEmailVerified;
  
  // Trusted: 10+ sales, rating > 4.5, verified
  const isTrusted = reviewCount >= 10 && rating >= 4.5 && isPhoneVerified && isEmailVerified;
  
  // Verified: phone + email verified
  const isVerified = isPhoneVerified && isEmailVerified;

  if (isElite) {
    return (
      <BadgeContainer className="gold" title="Elite Seller - 200+ sales, excellent rating">
        <span className="icon">👑</span>
        <span>Elite</span>
      </BadgeContainer>
    );
  }

  if (isPro) {
    return (
      <BadgeContainer className="gold" title="Pro Seller - 50+ sales, excellent rating">
        <span className="icon">⭐</span>
        <span>Pro</span>
      </BadgeContainer>
    );
  }

  if (isTrusted) {
    return (
      <BadgeContainer className="green" title="Trusted Seller - 10+ sales, great rating">
        <span className="icon">✓</span>
        <span>Confiable</span>
      </BadgeContainer>
    );
  }

  if (isVerified) {
    return (
      <BadgeContainer className="blue" title="Verified User - Phone and email verified">
        <span className="icon">✓</span>
        <span>Verificado</span>
      </BadgeContainer>
    );
  }

  // New user
  return (
    <BadgeContainer className="gray" title="New User">
      <span className="icon">👤</span>
      <span>Nuevo</span>
    </BadgeContainer>
  );
};

export default VerificationBadge;
